// extracted by mini-css-extract-plugin
export default {"container-switch":"switch_container-switch__Cgqbq","switch":"switch_switch__yte2R"};